import Backbone from "backbone";

export default Backbone.Model.extend({

      update: function () {
          this.set({
              days: this.getDays(),
              hours: this.getHours(),
              minutes: this.getMinutes(),
              seconds: this.getSeconds(),
              time: this.getTime()
          });

          return this;
      },

      getDays: function () {
          var days = Math.floor(this.getTime() / (60 * 60 * 24));

          return (days > 0) ? days : 0;
      },

      getHours: function () {
          var hours = Math.floor((this.getTime() / (60 * 60)) % 24);

          return (hours > 0) ? hours : 0;
      },

      getMinutes: function () {
          var minutes = Math.floor((this.getTime() / 60) % 60);

          return (minutes > 0) ? minutes : 0;
      },

      getSeconds: function () {
          var seconds = Math.floor(this.getTime() % 60);

          return (seconds > 0) ? seconds : 0;
      },
      getTime: function () {
          var timestamp = this.get('timestamp');

          return ((timestamp * 1000) - Date.parse(new Date())) / 1000 | 0;
      }

  });
